
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5347',
  depVersions: {
  "data-privacy-request-ui": "static-1.5347",
  "data-fetching-client": "static-1.9499",
  "head-dlb": "static-1.4841",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7827",
  "hub-http-shared-msw-handlers": "static-1.9527",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11256",
  "I18n": "static-7.1575",
  "jasmine-runner": "static-1.6294",
  "privacy-center-public-service-types": "static-1.4610",
  "quartz": "static-1.6765",
  "react-dlb": "static-1.73",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5394",
  "UIComponents": "static-3.8203",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.82",
  "foundations-assets": "static-1.4659",
  "foundations-components": "static-1.7569",
  "foundations-components-test-utils": "static-1.5052",
  "foundations-theming": "static-1.4235",
  "hub-http": "static-1.6042",
  "quartz-config": "static-1.543",
  "quartz-core": "static-1.5984",
  "quick-fetch": "static-1.3758",
  "raven": "static-3.5725",
  "react": "static-7.180",
  "react-rhumb": "static-1.16474",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10966",
  "usage-tracker": "static-1.7158",
  "usage-tracker-anonymous": "static-1.5575",
  "usage-tracker-core": "static-1.7008",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3250",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3042",
  "quartz-webpack": "static-1.2989",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "HeadJS": "static-2.713",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2938",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3926",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "react-utils": "static-2.5196",
  "StyleGuideUI": "static-3.484",
  "jasmine": "static-4.4149",
  "rpc-client-utils": "static-1.4457",
  "HubStyle": "static-2.11564",
  "ui-addon-draggable": "static-3.4588",
  "cssUtils": "static-1.739",
  "hs-story-utils": "static-1.9249",
  "icons": "static-2.623",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1099",
  "bend-plugin-foundations-components": "static-1.3838",
  "floating-ui": "static-1.52",
  "foundations-theming-specialty": "static-1.1951",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1282",
  "ui-fonts": "static-1.518",
  "foundations-components-legacy": "static-1.594",
  "bend-plugin-foundations-theming": "static-1.2718",
  "foundations-theming-base": "static-1.3220",
  "stylex": "static-1.28",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4499",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.440",
  "quartz-head": "static-1.430",
  "quartz-i18n": "static-1.440",
  "quartz-routing": "static-1.195",
  "quartz-test": "static-1.440",
  "quartz-tracking": "static-1.144",
  "usage-tracker-container": "static-1.7148",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2970",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.66",
  "sassPrefix": "static-1.152",
  "hubspotter-http-shared-msw-handlers": "static-1.9525"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5347",
  "data-fetching-client": "/data-fetching-client/static-1.9499",
  "head-dlb": "/head-dlb/static-1.4841",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7827",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9527",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11256",
  "I18n": "/I18n/static-7.1575",
  "jasmine-runner": "/jasmine-runner/static-1.6294",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4610",
  "quartz": "/quartz/static-1.6765",
  "react-dlb": "/react-dlb/static-1.73",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5394",
  "UIComponents": "/UIComponents/static-3.8203",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "foundations-assets": "/foundations-assets/static-1.4659",
  "foundations-components": "/foundations-components/static-1.7569",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5052",
  "foundations-theming": "/foundations-theming/static-1.4235",
  "hub-http": "/hub-http/static-1.6042",
  "quartz-config": "/quartz-config/static-1.543",
  "quartz-core": "/quartz-core/static-1.5984",
  "quick-fetch": "/quick-fetch/static-1.3758",
  "raven": "/raven/static-3.5725",
  "react": "/react/static-7.180",
  "react-rhumb": "/react-rhumb/static-1.16474",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10966",
  "usage-tracker": "/usage-tracker/static-1.7158",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5575",
  "usage-tracker-core": "/usage-tracker-core/static-1.7008",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3250",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3042",
  "quartz-webpack": "/quartz-webpack/static-1.2989",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "HeadJS": "/HeadJS/static-2.713",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2938",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3926",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "react-utils": "/react-utils/static-2.5196",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "jasmine": "/jasmine/static-4.4149",
  "rpc-client-utils": "/rpc-client-utils/static-1.4457",
  "HubStyle": "/HubStyle/static-2.11564",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4588",
  "cssUtils": "/cssUtils/static-1.739",
  "hs-story-utils": "/hs-story-utils/static-1.9249",
  "icons": "/icons/static-2.623",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1099",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3838",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1951",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1282",
  "ui-fonts": "/ui-fonts/static-1.518",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.594",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2718",
  "foundations-theming-base": "/foundations-theming-base/static-1.3220",
  "stylex": "/stylex/static-1.28",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4499",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.440",
  "quartz-head": "/quartz-head/static-1.430",
  "quartz-i18n": "/quartz-i18n/static-1.440",
  "quartz-routing": "/quartz-routing/static-1.195",
  "quartz-test": "/quartz-test/static-1.440",
  "quartz-tracking": "/quartz-tracking/static-1.144",
  "usage-tracker-container": "/usage-tracker-container/static-1.7148",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.66",
  "sassPrefix": "/sassPrefix/static-1.152",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9525"
}
};
